














import { Component, Vue } from 'vue-property-decorator'
import { State, Getter, Mutation, namespace } from 'vuex-class'
import Button from '../BaseButton.vue'
import ShippingInfo from './ShippingInfo.vue'
import BillingInfo from './BillingInfo.vue'
import PaymentInfo from './PaymentInfo.vue'
import ExpressCheckout from './ExpressCheckout.vue'
import Notification from '../BaseNotification.vue'

const cart = namespace('cart')

@Component({
  components: { Button, Notification, ShippingInfo, BillingInfo, PaymentInfo, ExpressCheckout },
})
export default class CustomerInfoInputs extends Vue {
  @cart.State paypalAvailable: boolean
  @cart.State globalErrorMessage: string
  @cart.State isVip: boolean
  @cart.State refId: string
  @cart.Mutation setGlobalError: any

  dismissNotification () {
    this.setGlobalError(null)
  }
}
